import { Storage } from "@capacitor/storage";
import { v4 as uuidv4 } from "uuid";
import { DbOptions, LocalDb } from ".";

export type JsonDbFilter = (key: string, data: any) => boolean;

const jsonDb: LocalDb = {
	create: async (
		data: any,
		partition: string,
		options?: DbOptions
	): Promise<string> => {
		const id = options?.avoidUUID ? partition : `${partition}::${uuidv4()}`;

		await Storage.set({
			key: id,
			value: JSON.stringify(data),
		});
		return id;
	},
	async update(id: string, patch: any): Promise<string> {
		const oldSystem = await Storage.get({
			key: id,
		}).then((s) => ({ ...s, value: JSON.parse(s.value!) }));
		const newValue = {
			...oldSystem.value,
			...patch,
		};

		await Storage.set({ key: id, value: JSON.stringify(newValue) });
		return id;
	},
	delete(id: string): Promise<void> {
		return Storage.remove({ key: id });
	},
	async get(id: string): Promise<any> {
		const result = await Storage.get({ key: id });
		const value = JSON.parse(result.value!);
		const valueIsArray = Array.isArray(value);

		if (value === null || value === undefined) {
			return false;
		}

		return typeof value === "object" && !valueIsArray
			? {
					...value,
					id,
			  }
			: value;
	},
	async find(filterFn: JsonDbFilter = () => true): Promise<any[]> {
		const storedKeys = await Storage.keys().then((result) =>
			result.keys.filter(filterFn)
		);
		const result = await Promise.all(
			storedKeys.map(async (k) => {
				const result = await Storage.get({ key: k });

				return {
					...JSON.parse(result.value!),
					id: k,
				};
			})
		);

		return result;
	},
	async exists(key: string): Promise<boolean> {
		// TODO: Review the line below
		const result = await Storage.get({ key: key });

		return !!result.value;
	},
};

export default jsonDb;
